<template>
  <div class="desktop-navigation show-for-mediumlarge">
    <div class="row menu">
      <div class="columns medium-13 medium-offset-1 large-10">

        <div class="logo-wrapper">
          <router-link :to="rootPath">
            <img class="page-logo" :src="logoUrl"/>

            <div class="site-name">
              <h3>{{ title }}</h3>
              <p v-if="teamsiteConfig.subtitle">{{ teamsiteConfig.subtitle }}</p>
            </div>
          </router-link>
        </div>
      </div>
      <div class="columns medium-9 large-12 links">
        <mq-link class="float-right contact-link" :destination="contact.url" size="small" :color="buttonColor" type="button">{{ contact.text }}</mq-link>
        <mq-navigation class="float-right" :navItems="navItems" :login="login"></mq-navigation>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DesktopNavigation',

    props: {
      header: {
        required: true,
        type: Object
      }
    },

    mounted() {
      this.addTrackingDataToRegisterButton({
        element: this.$el.querySelector('a.moqo_link.contact-link'),
        section: 'navigation-desktop'
      })
    },

    computed: {
      contact     () { return this.header.contact },
      login       () { return this.header.login },
      navItems    () { return this.header.navItems },
      rootPath    () { return this.header.rootPath },
      buttonColor () { return this.header.buttonColor },

      logoUrl () {
        let logo = this.teamsiteConfig.navigation_logo || this.teamsiteConfig.logo
        if (logo) {
          return logo.thumb_url || logo.medium_url || logo.url
        }
      },

      title () {
        return this.teamsiteConfig.title || this.teamsiteConfig.name
      }
    }
  }
</script>

<style lang="scss" scoped>

.menu {
  margin-bottom: 0;
  transition: margin 150ms;

  @include breakpoint(small only) {
    margin-top: 10rem;
  }

  a, router-link {
    color: $color-white !important;
  }

  .columns {
    overflow: hidden;
  }

  .header--with-bg & {
    margin-bottom: rem-calc(10);
    @include breakpoint(small only) {
      margin-top: 10rem;
      margin-bottom: rem-calc(25);
    }
  }
}

.logo-wrapper {
  // required for centering the logo vertically
  display: inline-block;
  height: 70px;
}

.contact-link {
  display: none;
  margin-left: 1.5rem;
  font-size: 0.8375rem;
  letter-spacing: 0.1rem;
  max-width: 14.75rem;
}

.site-name {
  top: 50%;
  position: relative;
  transform: translateY(-50%);
  float: left;
  margin-left: 20px;

  h3 {
    text-transform: initial;
    color: $color-white;
    margin: 0;
    line-height: rem-calc(20);
    font-size: rem-calc(28);
  }
  p {
    color: $color-white;
    margin: 0;
    margin-top: 5px;
    line-height: rem-calc(20);
    font-size: rem-calc(18);
  }
}

ul.navigation {
  margin-top: rem-calc(12);
}

.links {
  padding-top: rem-calc(14);
  float: left !important;
}

.page-logo {
  height: 100%;
  width: auto;
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/DesktopNavigation.vue